import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type MarketSettingsCostEditController from 'lumen/controllers/market/settings/cost/edit';
import type { CostModel } from 'lumen/routes/market/settings/cost';
import type { Transition } from 'lumen/services/transition';
import {
  setupUnsavedChangesTransitionHandler,
  type TransitionHandler,
} from 'lumen/utils/unsaved-changes-transition-handlers';

export type CostEditModel = CostModel & { profileId: string };

// Feature-toggle gating lives on the parent `market.settings.cost` route,
// whose `beforeModel` runs first and redirects before this route is entered.
export default class MarketSettingsCostEditRoute extends Route {
  @service declare router: Services['router'];

  #transitionHandler?: TransitionHandler;

  model(params: { profile_id: string }): CostEditModel {
    const model = this.modelFor('market.settings.cost') as CostModel;

    return { ...model, profileId: params.profile_id };
  }

  resetController(
    controller: MarketSettingsCostEditController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      this.#transitionHandler?.cleanup();
      this.#transitionHandler = undefined;
    }
  }

  setupController(
    controller: MarketSettingsCostEditController,
    model: CostEditModel,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    void controller.loadTask.perform();

    this.#transitionHandler = setupUnsavedChangesTransitionHandler(
      this.router,
      controller,
      'market.settings.cost.edit',
    );
  }
}
